const appConfig = {
  "name": "leave-supervisor-v2-test",
  "version": "0.1.0",
  "stage": "test",
  "deployThisBuild": false,
  "okta": {
    "issuer": "https://okta.mit.edu/oauth2/aus6shd5478WH30vd697",
    "clientId": "46r56sp10veorip9m5qj4mp821",
    "redirectUris": [
      "https://leave-supervisor-v2.atlas-apps-test.mit.edu"
    ],
    "postLogoutRedirectUris": [
      "https://leave-supervisor-v2.atlas-apps-test.mit.edu/logout"
    ],
    "scopes": [
      "address",
      "digital-id/search",
      "digital-id/user",
      "email",
      "feature/user",
      "offline_access",
      "openid",
      "phone",
      "profile",
      "sap-proxy/execute-rfc",
      "sap-proxy/function",
      "sap-proxy/status",
      "user/all"
    ]
  },
  "amplify": {
    "userPoolId": "us-east-1_nY154N4yV",
    "userPoolWebClientId": "46r56sp10veorip9m5qj4mp821",
    "oauth": {
      "domain": "atlas-auth-test.mit.edu",
      "scope": [
        "digital-id/search",
        "digital-id/user",
        "feature/user",
        "openid",
        "profile",
        "sap-proxy/function",
        "sap-proxy/status"
      ],
      "redirectUris": [
        "https://leave-supervisor-v2.atlas-apps-test.mit.edu"
      ],
      "postLogoutRedirectUris": [
        "https://leave-supervisor-v2.atlas-apps-test.mit.edu/logout"
      ],
      "responseType": "token",
      "options": {
        "AdvancedSecurityDataCollectionFlag": false
      }
    }
  }
};
export default appConfig;